(function () {
    'use strict';


    function AccountingController($scope, Idle, $window, Global, MeanUser, $uibModal, $state, accountingConstant, Charts, userService) {
        $scope.global = Global;
        $scope.user = MeanUser.user;
        $scope.package = {
            name: 'accounting'
        };
        $scope.currentTab = '';
        $window.scrollTo(0, 0);
        $scope.warning = null;
        $scope.timedout = null;
        $scope.accountingConstant = accountingConstant;
        $scope.idle = $scope.accountingConstant.idleTime;
        $scope.timeout = $scope.accountingConstant.timeoutTime;
        $scope.init = function () {
            var isAccountAccess = localStorage.getItem('accessgranted');
            if (isAccountAccess === 'true') Idle.watch();
            else {
                localStorage.setItem('accessgranted', false);
                $state.go('admin-panel trade admin');
            }

        };
        userService.getMainAccountId($scope.user.username).then(function (id) {
            $scope.clientAccountId = id;
            Charts.query({isDeleted: false, userId: $scope.clientAccountId});
        })

        $scope.back = () => {
            $scope.currentTab = '';
        }

        $scope.dissmiss = function () {
            closeModals();
            $state.go('admin-panel trade admin');
        }

        $scope.onSelectPage = (select) => {
            $scope.currentTab = select;
        }

        function closeModals() {
            if ($scope.warning) {
                $scope.warning.close();
                $scope.warning = null;
            }
            if($scope.timedout) {
                $scope.timedout.close();
                $scope.timedout = null;
            }
        }

        $scope.start = function () {
            closeModals();
            Idle.watch();
        };

        $scope.$on('IdleStart', function () {
            closeModals();
            $scope.warning = $uibModal.open({
                templateUrl: 'warning-dialog.html',
                windowClass: 'session-modal-warning'
            });
        });

        $scope.$on('IdleEnd', function () {
            closeModals();
        });

        $scope.$on('IdleWarn', function (e, countdown) { });
        $scope.$on('IdleTimeout', function () {
            closeModals();
            Idle.unwatch();
            localStorage.setItem('accessgranted', false);
            $scope.timedout = $uibModal.open({
                templateUrl: 'timedout-dialog.html',
                scope: $scope,
                windowClass: 'session-modal-danger' 
            });

            $scope.timedout.result.then(function(){
                $scope.dissmiss();
            }, function(){
                $scope.dissmiss();
            });
            
        });

        $scope.$on('Keepalive', function () {
            Idle.watch();
        });

        $scope.$watch('idle', function (value) {
            if (value !== null) Idle.setIdle(value);
        });
        $scope.$watch('timeout', function (value) {
            if (value !== null) Idle.setTimeout(value);
        });
    }
    //End the Parent Function

    angular
        .module('mean.accounting').config(function (IdleProvider, KeepaliveProvider, TitleProvider) {
            TitleProvider.enabled(false);
            KeepaliveProvider.interval(300);
            IdleProvider.windowInterrupt('focus');
        })
        .run(function ($rootScope, Idle, $log, Keepalive) {
            Idle.watch();
        })
        .controller('AccountingController', AccountingController);

    AccountingController.$inject = ['$scope', 'Idle', '$window', 'Global', 'MeanUser', '$uibModal', '$state', 'accountingConstant', 'Charts', 'userService'];
})();



// WEBPACK FOOTER //
// ./packages/custom/accounting/public/controllers/accounting.js